export default "__VITE_ASSET__dDU8f810__"